<div class="card">
    <h1 class="title">PQCIFRIS25: La migrazione alla crittografia post-quantum</h1>
    <p class="subtitle">
        Online e in presenza a Roma, presso <strong>Poste Italiane</strong>, il <strong>5 novembre 2025</strong>.
        Un evento promosso da <strong>De Cifris</strong> dedicato alla ricerca e alla transizione verso la
        crittografia post-quantum.
    </p>
</div>

<section class="grid">
    <main>
        <div class="card">
            <h2>About PQCIFRIS25</h2>
            <p>
                PQCIFRIS25 è un incontro nazionale dedicato alla migrazione verso la crittografia post-quantum,
                organizzato da <strong>De Cifris</strong> e dai membri della sezione <strong>PQCifris</strong>.
                L’evento combina momenti di ricerca, contributi istituzionali e testimonianze operative, con un
                format misto: online e in presenza a Roma.
            </p>
        </div>

        <div class="card" style="margin-top:18px">
            <h2 id="schedule" style="margin-top:18px">Programma</h2>
            <p class="meta">(Fuso orario: Roma, CEST)</p>

            <table>
                <tr>
                    <td class="schedule-time">05 Nov • 10:00-12:00</td>
                    <td><strong>Sessione I</strong>: Ricerca italiana in crittografia post-quantum</td>
                </tr>
                <tr>
                    <td class="schedule-time">05 Nov • 12:00-13:30</td>
                    <td>Pausa</td>
                </tr>
                <tr>
                    <td class="schedule-time">05 Nov • 13:30-14:45</td>
                    <td><strong>Sessione II</strong>: De Cifris Partners</td>
                </tr>
                <tr>
                    <td class="schedule-time">05 Nov • 14:45-15:00</td>
                    <td>Pausa</td>
                </tr>
                <tr>
                    <td class="schedule-time">05 Nov • 15:00-17:00</td>
                    <td><strong>Sessione III</strong>: Post-quantum <em>atelier</em></td>
                </tr>
            </table>
            <h2>Sessione I: Ricerca italiana in crittografia post-quantum</h2>
            <p>
                Vi sono una decina di gruppi di ricerca accademica in Italia che si occupano di crittografia
                post-quantum. Tutti aderiscono a De Cifris, sezione PQCifris. Numerosi ricercatori italiani
                operano inoltre all’estero. In questa sessione, una selezione di membri di PQCifris presenterà
                le loro ricerche più significative:
            </p>
            <ul>
                <li>UniMI (Alessandro Barenghi) - Implementazione veloce di codici post-quantum
                    <br><a href="https://drive.google.com/file/d/1zCarOG5BjwkT_MzSjTJYZ9K_ABMJ84Ek/view?usp=drive_link" target="_blank">Slides (Barenghi)</a>
                </li>
                <li>PoliTO (Andrea Gangemi) - The role of cryptographic group actions in the post-quantum era
                    <br><a href="https://drive.google.com/file/d/15xlesnv0Yzkue625oDM-KG3VaQk7qZJ0/view?usp=drive_link" target="_blank">Slides (Gangemi)</a>
                </li>
                <li>UniBA (Roberto La Scala) - Cryptography and Cryptanalysis: Perspectives from the University of Bari
                    <br><a href="https://drive.google.com/file/d/1eB-3sNP-mZNE6HWeV6NYl1_7PS_WzLjq/view?usp=drive_link" target="_blank">Slides (La Scala)</a>
                </li>
                <li>UniRoma2 (Guido Lido Maria) - SQISign e SQInstructor: curve ellittiche e torsione
                    <br><a href="https://drive.google.com/file/d/1o3qdpRj_7qRWbqzU9O2A_7QLfHvjuEzg/view?usp=drive_link" target="_blank">Slides (Lido Maria)</a>
                </li>
                <li>UniCAS (Rosa Fera) - Overview on Oil & Vinegar systems through algebraic invariants
                    <br><a href="https://drive.google.com/file/d/1TW13Q32D7h4zAzabZdDSbtvzuuKbtWka/view?usp=drive_link" target="_blank">Slides (Fera)</a>
                </li>
                <li>UniCAMPANIA (Ferdinando Zullo) - A ROLLO‐type cryptosystem based on group algebras
                    <br><a href="https://drive.google.com/file/d/16bq8RGwAiApwul2HQ3J3LWllJJIHI5im/view?usp=drive_link" target="_blank">Slides (Zullo)</a>
                </li>
                <li>UniGE (Alessio Caminata) - Quadratic Modelings of Syndrome Decoding
                    <br><a href="https://drive.google.com/file/d/1xIH2i7exlxVgo46E_b_BwRo619fVIBmX/view?usp=drive_link" target="_blank">Slides (Caminata)</a>
                </li>
                <li>UniTN (Federico Pintore) - Post-quantum digital signatures
                    <br><a href="https://drive.google.com/file/d/140GjOfIg7p4GXP1b3jFtIm2cSfFVHoo4/view?usp=drive_link" target="_blank">Slides (Pintore)</a>
                </li>
                <li>UniVPM (Marco Baldi) - (Due Presentazioni)
                    <br><a href="https://drive.google.com/file/d/192sBUiI9O65jOF1vVDC9H4JHipRlLa4N/view?usp=drive_link" target="_blank">Slides I (Baldi)</a>
                    <br><a href="https://drive.google.com/file/d/1KKD95lUznNE23ir0uQQYLcZs3KRqnChX/view?usp=drive_link" target="_blank">Slides II (Baldi)</a>
                </li>
                <li>UniCAS (Domenico Capriglione e Rosa Fera) - 
                    <br><a href="https://drive.google.com/file/d/1HcegNPvVee8MzD4iZbTwNiC59XAB9toJ/view?usp=drive_link" target="_blank">Slides (Capriglione/Fera)</a>
                </li>
                
                <li>UniMI (Samuele Bompani) - Efficient Implementations of Post-Quantum Schemes
                    <br><a href="https://drive.google.com/file/d/1CAqKCjr1yQx3EE21GD-AeN4N2aBG45QW/view?usp=drive_link" target="_blank">Slides (Bompani)</a>
                </li>
                <li>Presentazione aggiuntiva (Paolo Santini)
                    <br><a href="https://drive.google.com/file/d/1PGYWu0hF_WJ19Lt8BMl-tkQDQ8BEv_2N/view?usp=drive_link" target="_blank">Slides (Santini)</a>
                </li>
            </ul>

            <h2 style="margin-top:18px">Sessione II: De Cifris Partners</h2>
            <p>
                Questa sessione è aperta da un intervento di <strong>ACN</strong>, seguito dai partner di De Cifris.
                De Cifris non prende posizione sulle presentazioni dei partner. <br>
                <strong>Moderatore:</strong> Ing. Andrea Gelpi (responsabile partner De Cifris)
            </p>
            <ul>
                <li>13:30 ACN</li>
                <li>13:45 Think Quantum</li>
                <li>14:00 QTI</li>
                <li>14:15 Random Power
                    <br><a href="https://docs.google.com/presentation/d/1al2BjCvaHlNoZObQKrXUXpguOCFVPnQt/edit?usp=drive_link&ouid=105473800080178257163&rtpof=true&sd=true" target="_blank">Slides (Caccia)</a>
                </li>
                <li>14:30 Deloitte</li>
            </ul>

            <h2 style="margin-top:18px">Sessione III: Post-quantum <em>atelier</em></h2>
            <p>
                Apertura con presentazione dei ricercatori di PQCifris, seguita da importanti realtà italiane
                che illustrano esperienze preliminari di migrazione post-quantum. <br>
                <strong>Moderatore:</strong> Prof. Massimiliano Sala (Presidente De Cifris)
            </p>
            <ul>
                <li>15:00 Ricerca PQCifris</li>
                <li>15:20 Banca d’Italia</li>
                <li>15:40 Intesa San Paolo</li>
                <li>16:00 ENI</li>
                <li>16:20 TIM</li>
                <li>16:40 Poste</li>
            </ul>
        </div>

        <div class="card" style="margin-top:18px">
            <h2>Note & Logistica</h2>
            <ul>
                <li><strong>Modalità:</strong> Online + presenza a Roma (Poste Italiane).</li>
                <li><strong>Partecipazione:</strong> aperta a ricercatori, studenti e professionisti del settore.</li>
                <li><strong>Lingua:</strong> Italiano.</li>
                <li><strong>Quota:</strong> partecipazione gratuita, previa registrazione.</li>
                <li><strong>Registrazione:</strong> disponibile su <a href="https://decifris.it" target="_blank">decifris.it</a>.</li>
            </ul>
        </div>
    </main>

    <aside>
        <div class="card">
            <h2>Dettagli</h2>
            <div><strong>Data:</strong> 5 novembre 2025</div>
            <div><strong>Luogo:</strong> Online + Roma, sede <strong>Poste Italiane</strong></div>
            <div><strong>Organizzazione:</strong> De Cifris</div>
            <div><strong>Format:</strong> Sessioni di ricerca, panel istituzionali, atelier tecnico.</div>
            <a class="btn ghost" href="mailto:segreteria@decifris.it">Contatto: segreteria&#64;decifris.it</a>
        </div>
    </aside>
</section>